module.exports = __webpack_public_path__ + "static/media/adamLiberman.6f5e8c36.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/adamLiberman.jpg
// module id = 1658
// module chunks = 1